import React from 'react'
import './Bonus.scss';
import BonusImage from '../../../../assets/BonusImage.png';

export default function Bonus() {
  return (
    <div className='bonus-container'>
      <div className='left-section'>
        <img src={BonusImage} alt="earn bonus" />
      </div>
      <div className='right-section'>
        <h1>Daily visiting bonus</h1>
        <p>
          Stay active and get rewarded! Every day you visit the app or website, you’ll automatically receive 5 free coins. It’s our way of saying thank you for being part of the MyPDF.club community.
        </p>
      </div>
    </div>
  )
}
